import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension'
import { getConfig } from './appConfig'
import rootSaga from './store/rootSaga'
import reducers from './store/rootReducer'
import App from './App';
import reportWebVitals from './reportWebVitals';

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Josefin-Regular',
    ].join(','),
  },});

const sagaMiddleware = createSagaMiddleware()

let middleware = applyMiddleware(sagaMiddleware)
if (getConfig().general.isReduxDevToolsOn) {
	middleware = composeWithDevTools(applyMiddleware(sagaMiddleware))
}

export const store = createStore(
	reducers,
	middleware
)

sagaMiddleware.run(rootSaga)




ReactDOM.render(
  <React.StrictMode>
    <Provider store={ store }>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
